;(function (module) {
  'use strict'
  module.controller('TopBarController', [
    '$q',
    '$scope',
    '$state',
    '$timeout',
    'alertService',
    'authService',
    'organizations',
    'clientSelectService',
    'agencySelectService',
    'socketLogin',
    'obexRoles',
    'pushService',
    'ngDialog',
    function (
      $q,
      $scope,
      $state,
      $timeout,
      alertService,
      authService,
      organizations,
      clientSelectService,
      agencySelectService,
      socketLogin,
      obexRoles,
      Push,
      ngDialog,
    ) {
      //init of page
      console.log('******* TopBarController')
      $scope.showAlert = false
      // Options
      $scope.introOptions = {
        steps: [
          {
            element: '#orgInput',
            intro: 'Select a client to begin.',
            position: 'bottom',
          },
        ],
        showStepNumbers: false,
        showProgress: false,
        showBullets: false,
        exitOnOverlayClick: true,
        exitOnEsc: true,
        nextLabel: 'Next',
        prevLabel: 'Back',
        skipLabel: 'Skip',
        doneLabel: '<i class="fa fa-fw fa-check"></i> Got it!',
      };
      $scope.currentState = $state;

      let selectableAgencies = [];
      let selectableClients = [];

      // Intro on first app load
      /*
      const storage = $window.localStorage;
      if (storage.getItem('firstLoad') == null) {
        storage.setItem('firstLoad', true);
      }

      $scope.firstLoad = storage.getItem('firstLoad') == 'true';
      if ($scope.firstLoad) {
        $timeout(function () {
          $scope.initIntro();
        }, 500); // Delay for DOM to settle
        storage.setItem('firstLoad', false);
      }*/

      const logInUser = authService.getLoginMember()

      if (logInUser) {
        $scope.organizationId = logInUser.Organization.Id;
        $scope.organizationName = logInUser.Organization.Name;
        $scope.allowOpenBookings = logInUser.Organization.AllowOpenBookings;
        $scope.firstName = logInUser.FirstName;
        $scope.lastName = logInUser.LastName;
        socketLogin.setLoginMemberAndSend(logInUser);
        $scope.logInUserRole = logInUser.Role;
        if (logInUser.Role == 4) {
          //$scope.introOptions.steps[0].intro = "Select an agency and then a client to begin.";
        }
      } else {
        $scope.organizationName = ''
        $scope.firstName = ''
        $scope.lastName = ''
      }

      const hideStates = [
        'app.clientManagement',
        'app.addClient',
        'app.editClient',
        'app.editClient',
        'app.providers',
        'app.addProvider',
        'app.editProvider',
        'app.categories',
        'app.addCategory',
        'app.editCategory',
        'app.apps',
        'app.addApp',
        'app.editApp',
        'app.agents',
        'app.sms',
        'app.sms-notif',
        'app.changePassword',
      ]
      function findInHiddenList(state) {
        return state === $state.current.name
      }
      const stateInHiddenList =
        _.find(hideStates, findInHiddenList) !== undefined
      $scope.hideAgencyDropdown = stateInHiddenList || logInUser.Role !== 4
      $scope.hideClientDropdown = stateInHiddenList

      console.log('$scope.hideAgencyDropdown ', $scope.hideAgencyDropdown)
      console.log('$scope.hideClientDropdown ', $scope.hideClientDropdown)

      agencySelectService.getSelectableAgencies().then(function (response) {
        selectableAgencies = response
        $scope.selectableAgencies = selectableAgencies
        console.log('Got selectable agencies ', $scope.selectableAgencies)

        if ($scope.selectableAgencies.length == 1) {
          agencySelectService.setSelectedAgency(
            $scope.selectableAgencies[0].id,
            $scope.selectableAgencies[0].name
          );
        }

        if (logInUser.Role === obexRoles.roleTravelAgencyAdmin || logInUser.Role === obexRoles.roleTravelAgent) {
          agencySelectService.setSelectedAgency(
            $scope.organizationId,
            $scope.organizationName,
            $scope.allowOpenBookings
          );
          clientSelectService
            .getAgencyClients($scope.organizationId)
            .then(function (response) {
              $scope.selectableClients = response;
            });
        }
      });

      const selectableAgenciesPromise = agencySelectService.getSelectableAgencies();
      const loginOrganizationPromise = organizations.getOrganizationById(
        $scope.organizationId
      );

      $q.all([selectableAgenciesPromise, loginOrganizationPromise]).then(
        function (response) {
          selectableAgencies = response[0];
          $scope.selectableAgencies = selectableAgencies;
          console.log("Got selectable agencies ", $scope.selectableAgencies);

          if ($scope.selectableAgencies.length == 1) {
            agencySelectService.setSelectedAgency(
              $scope.selectableAgencies[0].id,
              $scope.selectableAgencies[0].name
            );
          }
          console.log("Selected agency ",agencySelectService.getSelectedAgency());
          $scope.LogoImageLink = response[2].data.LogoImageLink;
        }
      );

      //agency
      $scope.$watchGroup(
        ['selectedAgencyId', 'selectedAgencyName'],
        function (newValues, oldValues) {
          if (newValues[0] && newValues[1]) {
            agencySelectService.setSelectedAgency(newValues[0], newValues[1])
            $timeout(function () {
              // Delay button show to match textbox animation duration
              $scope.clear_agency_visible = true
            }, 301)
          } else {
            //console.log('No filter');
            document.getElementById('agencyDropdown').className +=
              ' animatedBorder'
            document.getElementById('clientDropdown').className +=
              ' animatedBorder'
          }
        },
        true,
      )

      // Watch selected client values and set client accordingly
      $scope.$watchGroup(
        [
          'selectedClientId',
          'selectedClientName',
          'selectedClientAllowOpenBookings',
          'selectdClientChatAppName',
        ],
        function (newValues, oldValues) {
          if (newValues[0] && newValues[1]) {
            clientSelectService.setSelectedClient(
              newValues[0],
              newValues[1],
              newValues[2],
              newValues[3]
            )
            $timeout(function () {
              // Delay button show to match textbox animation duration
              $scope.clear_client_visible = true
            }, 301)
          } else {
            //console.log('No filter');
            document.getElementById('clientDropdown').className +=
              ' animatedBorder'
          }
        },
        true,
      )

      // Get persisting filtered organization on load
      let filterClient = clientSelectService.getSelectedClient();
      if (filterClient) {
        $scope.clientInput = filterClient.name;
        $scope.selectedClientId = filterClient.id;
        $scope.selectedClientName = filterClient.name;
        $scope.selectedClientAllowOpenBookings = filterClient.allowOpenBookings;
        $scope.selectdClientChatAppName = filterClient.ChatAppName
      } else {
        $scope.clientInput = undefined;
        $scope.selectedClientId = undefined;
        $scope.selectedClientName = undefined;
        $scope.selectedClientAllowOpenBookings = undefined;
        $scope.selectdClientChatAppName = undefined;
      }

      // Set selected client
      $scope.setSelectedClient = function (item) {
        $scope.selectedClientId = item.id
        $scope.selectedClientName = item.name
        $scope.selectdClientChatAppName = item.ChatAppName
        $('#clientDropdown').removeClass('animatedBorder')
        $scope.selectedClientAllowOpenBookings = item.allowOpenBookings
      }

      // Clear selected client
      $scope.clearSelectedClient = function () {
        $scope.clear_client_visible = false;
        $scope.clientInput = undefined;
        $scope.selectedClientId = undefined;
        $scope.selectedClientName = undefined;
        $scope.selectdClientChatAppName = undefined;
        document.getElementById("clientDropdown").className +=
          " animatedBorder";
        $scope.selectedClientAllowOpenBookings = undefined;
        clientSelectService.clearSelectedClient();
        console.log("$scope.selectableClients ", $scope.selectableClients);
        console.log("agencySelectService.getSelectedAgency().id ",agencySelectService.getSelectedAgency().id);
        if (logInUser.Role !== 4) {
          $scope.getClients($scope.organizationId);
        } else {
          const selectedAgency = agencySelectService.getSelectedAgency().id;
          $scope.getClients(selectedAgency);
        }
      };

      $scope.isClientSelected = function () {
        return (
          !!$scope.selectedClientId ||
          !!$scope.selectedClientName ||
          !!$scope.selectedClientAllowOpenBookings ||
          !!$scope.selectdClientChatAppName
        )
      }

      // Get persisting filtered agency on load

      let filterAgency = agencySelectService.getSelectedAgency()
      if (filterAgency) {
        $scope.agencyInput = filterAgency.name
        $scope.selectedAgencyId = filterAgency.id
        $scope.selectedAgencyName = filterAgency.name
      } else {
        $scope.agencyInput = undefined;
        $scope.selectedAgencyId = undefined;
        $scope.selectedAgencyName = undefined;
        $scope.clear_agency_visible = false;
      }

      // Set selected agency
      $scope.setSelectedAgency = function (item) {
        $scope.selectedAgencyId = item.id;
        $scope.selectedAgencyName = item.name;
        $("#agencyDropdown").removeClass("animatedBorder");
        console.log("$scope.selectableClients line no 254 ", selectableClients);
        $scope.getClients(item.id);
      };

      $scope.viewMyProfile = function () {
        $scope.loginMember = authService.getLoginMember();
        $scope.loginMemberRoleName = getRoleName($scope.logInUserRole);
        ngDialog.open({
          template: 'dlg-template-my-profile',
          className: 'ngdialog-theme-plain',
          scope: $scope,
        })
      }

      function getRoleName(loginUserRole) {
        if (loginUserRole == 4) {
          return 'Obex Admin'
        } else if (loginUserRole == 3) {
          return 'Travel Manager'
        } else if (loginUserRole == 2) {
          return 'Travel Agency Admin'
        } else if (loginUserRole == 1) {
          return 'Travel Agent'
        } else {
          return 'User'
        }
      }
      // Clear selected agency
      $scope.clearSelectedAgency = function () {
        $scope.clear_agency_visible = false
        $scope.agencyInput = undefined
        $scope.selectedAgencyId = undefined
        $scope.selectedAgencyName = undefined
        document.getElementById('agencyDropdown').className += ' animatedBorder'
        agencySelectService.clearSelectedAgency()

        $scope.clearSelectedClient()
        $scope.selectableClients = []
      }

      $scope.isAgencySelected = function () {
        return !!$scope.selectedAgencyId || !!$scope.selectedAgencyName
      }

      $scope.getClients = function (id) {
        clientSelectService.getAgencyClients(id).then(function (response) {
          $scope.selectableClients = response;
        });
      };

      function updateAlertCount() {
        alertService.getUnhandledAlerts().then(function (response) {
          var unhandledAlerts = response.data
          var groups = _.groupBy(unhandledAlerts, function (alert) {
            return (
              alert.FromNumber + '#' + alert.FirstName + '#' + alert.LastName
            )
          })
          //$scope.alertCount = unhandledAlerts.length > 0 ? unhandledAlerts.length : '';
          $scope.alertCount = _.size(groups) > 0 ? _.size(groups) : ''
          $scope.showAlert = true
        })
      }

      function updateVoiceAlertCount() {
        alertService.getUnhandledVoiceAlerts().then(function (response) {
          const unhandledVoiceAlerts = response.data
          $scope.alertCountVoice = !!unhandledVoiceAlerts.length
            ? unhandledVoiceAlerts.length
            : ''
        })
      }

      function notifyDesktop(data) {
        console.log(data);
        const text = `From: ${data.member.DisplayName} (${data.member.Organization.Name}) \n Phone Number: ${data.fromNumber} \n ${data.message}`;
        Push.create('Obex Notification', {
          tag: 'notifyDesktop',
          icon: '/images/icons/obex32.png',
          body: text,
          link: '/#!/',
          requireInteraction: true,
          timeout: 300000,
          onClick: function () {
            window.focus()
            Push.close('notifyDesktop')
            Push.clear()
          },
          vibrate: [200, 100, 200, 100, 200, 100, 200],
        })
      }

      updateAlertCount()
      updateVoiceAlertCount()

      //on socket events
      $scope.$on('updateAlertCount', function (event, data) {
        updateAlertCount()
      })

      $scope.$on('updateAlertCountVoice', function (event, data) {
        console.log('updateAlertCountVoice ', data)
        updateVoiceAlertCount()
      })

      $scope.$on('notifyDesktop', function (event, data) {
        notifyDesktop(data)
      })

      //on user's actions
      $scope.gotoSmsNotif = function () {
        $scope.showAlert = false
        $state.go('app.sms-notif', {})
      }

      $scope.gotoPhoneNotif = function () {
        $state.go('app.phone-notif', {})
      }

      $scope.menuToggle = function () {
        if ($('#sidebar').hasClass('show')) {
          $('#sidebar').removeClass('show').addClass('hide')
          $('#page-wrapper').css({
            margin: '0px',
          })
        } else {
          setTimeout(
            function () {
              $('#sidebar').removeClass('hide').addClass('show')
            },

            500,
          )
          $('#page-wrapper').css({
            margin: '0 0 0 250px',
          })
        }
      };
    },
  ])
})(angular.module('obex'))



// WEBPACK FOOTER //
// ./client/js/controllers/topBarController.js